import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Warning from "./Warning";
import { RootReducer } from "../../store/reducers";
import { DeletePedestrianDelegeesModel } from "../../models/vehicle-assignments/DeletePedestrianDelegeesModel";
import { deletePedestrianDelegees } from "../../services/pedestrianRights.service";
import useAppContext from "../../context/hooks/useAppContext";
import { useAppDispatch } from "../../store";
import { toggleShowDeletePedestrianDelegeesAction } from "../../store/actions/pedestrianRights.actions";

interface IFormProps extends StateProps {
    selectedPedestrianIds: string[];
    onRefresh: () => void;
}

const DeletePedestrianDelegeesWarning = ({
    parkingProducts,
    selectedPedestrianIds,
    onRefresh
}: IFormProps) => {
    const { t } = useTranslation(["deletePedestrianDelegeesWarning", "globals"]);
    const { appState } = useAppContext();
    const dispatch = useAppDispatch();
    const warningText = t("warning", {count: selectedPedestrianIds.length});
    const warningDetails = t("details", { count: selectedPedestrianIds.length });
    const toggleDeletePedestrianDelegeesWarning = () => dispatch(toggleShowDeletePedestrianDelegeesAction());

    const handleDeleteCancellation = () => {
        toggleDeletePedestrianDelegeesWarning();
    }

    const handleSuccessfulDelete = () => {
        toggleDeletePedestrianDelegeesWarning();
        onRefresh();
    }

    const handleDeleteConfirmation = () => {
        const model: DeletePedestrianDelegeesModel = {
            delegeeIds: selectedPedestrianIds,
        };
        dispatch(deletePedestrianDelegees(model, handleSuccessfulDelete));
    }
    
    return (
        <Warning
            warning={warningText}
            details={warningDetails}
            onCancel={handleDeleteCancellation}
            onConfirm={handleDeleteConfirmation}
            disabled={false}
            confirmText={t("globals:delete")}
            loading={parkingProducts.loading}
        />
    );
};

const mapStateToProps = (state: RootReducer) => {
  const { parkingProducts } = state;

  return {
    parkingProducts,
  };
};


type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(DeletePedestrianDelegeesWarning);
